<up-top-header />

<bt-sidenav></bt-sidenav>
<div class="shift-right page-margins m-margin-none">
	<router-outlet></router-outlet>
</div>
